// eslint-disable-next-line import/order
import { captureRemixErrorBoundaryError, withSentry } from '@sentry/remix'

import { useEffect } from 'react'

import createCache from '@emotion/cache'
// eslint-disable-next-line import/order
import { CacheProvider } from '@emotion/react'

declare global {
  interface Window {
    dataLayer: unknown[]
  }
}

import { LinksFunction, MetaFunction } from '@remix-run/node'
import {
  Links,
  Meta,
  Outlet,
  Scripts,
  ScrollRestoration,
  useRouteError,
} from '@remix-run/react'
// eslint-disable-next-line @typescript-eslint/naming-convention
import ReactGA from 'react-ga4'

import {
  CustomErrorPage,
  RootErrorBoundary,
  TopFooter,
  TopHeader,
} from './features'
import './tailwind.css'

// FIXME: ここはビジネス側と相談して後で正しいものに置き換える
export const meta: MetaFunction = () => {
  return [
    {
      title: 'オフィスマップ | シェアオフィス コワーキングスペース検索サイト',
    },
    {
      name: 'description',
      content:
        'シェアオフィス コワーキングスペース検索サイト。シェアオフィスの詳細情報、地図、アクセス方法を確認できます。',
    },
  ]
}
export const links: LinksFunction = () => {
  return [
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;700&display=swap',
    },
  ]
}

export function ErrorBoundary() {
  const error = useRouteError()
  captureRemixErrorBoundaryError(error)
  return (
    <RootErrorBoundary>
      <div className="flex min-h-screen flex-col">
        <TopHeader />
        <div className="flex flex-grow items-center justify-center">
          <CustomErrorPage error={error} />
        </div>
        <TopFooter />
      </div>
    </RootErrorBoundary>
  )
}

// Create Emotion cache instance for consistent SSR/Client rendering
const emotionCache = createCache({
  key: 'office-map',
  prepend: false, // Ensure Tailwind CSS takes precedence
})

export function Layout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // initialize Clarity
    import('@microsoft/clarity').then((clarity) => {
      clarity.default.init('q0r7ru9fdp')
    })

    // Google Tag Manager
    const gtmScript = document.createElement('script')
    gtmScript.async = true
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=GTM-KKFTVX32`
    document.head.appendChild(gtmScript)

    // Google Tag Manager (noscript)
    const noscript = document.createElement('noscript')
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KKFTVX32"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    document.body.insertBefore(noscript, document.body.firstChild)

    // Google tag (gtag.js)
    ReactGA.initialize('G-MFJ57HQCM2')
    ReactGA.send('pageview')
  })

  return (
    <html lang="en">
      <head>
        <meta charSet="utf-8" />
        <meta content="width=device-width, initial-scale=1" name="viewport" />
        <meta
          content="emotion-insertion-point"
          name="emotion-insertion-point"
        />
        <Meta />
        <Links />
      </head>

      <body>
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

function App() {
  return (
    <CacheProvider value={emotionCache}>
      <Outlet />
    </CacheProvider>
  )
}

export default withSentry(App)
